import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { Link } from '../Link';

function ArrowLink({ title, link, href, color }) {
  return (
    <Box
      as={Link}
      display='flex'
      to={link}
      href={href}
      _hover={{
        textDecoration: 'none',
      }}
      alignItems='center'
      color={color || 'navy'}
      gap={5}
      mt={10}
      target={href?.startsWith('http') ? '_blank' : undefined}
      data-group
    >
      <Text textStyle='navItem' color='inherit' fontWeight={600}>
        {title}
      </Text>
      <ArrowForwardIcon
        transition='transform 1s ease-in-out'
        _groupHover={{
          transform: 'translateX(5px)',
        }}
      />
    </Box>
  );
}

export default ArrowLink;
